exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".usermsg[data-v-695cf818]{height:93%;background:#f3f3f3}.imgbox[data-v-695cf818]{text-align:center}.usermsg img[data-v-695cf818]{width:100px;height:100px;border-radius:10px;margin:20px 0}.usermsg>p[data-v-695cf818]{padding-left:10px;font-size:13px;color:#7f7f7f}.usermsg .title[data-v-695cf818]{margin-top:10px}#msg_el[data-v-695cf818]{border-bottom:1px solid #d6d5d5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-695cf818","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/user_msg.vue
// module id = 57
// module chunks = 0